import { useState, useEffect, useCallback, useRef } from "react";
import showAlert from "../../../server/ShowAlert";
import { Payment } from "../../../server/Payment";
import { GetCards } from "../../../server/Payment";
import PayNedarim from "./PayNedarim";
import { useDispatch } from "react-redux";
import { setPreload } from "../../../server/CartsOpen";
import SelectNumPay from "./PayNum";
import { useSelector } from "react-redux";
import { formatPrice } from "../../../utils/formatPrice";

const PayPopup = ({
  closePayPopup,
  tranmode,
  SumPay,
  orderId,
  coupons = [],
  comment,
  deferredDeliveryFee = null,
  embedded = false,
}) => {
  const user = useSelector((state) => state.user.user);
  const dispatch = useDispatch();
  const [sum, _setSum] = useState(null);
  const [save, setSave] = useState(false);
  const [cardId, setCardId] = useState(null);
  const [Cards, setCards] = useState([]);
  const [ShowCards, setShowCards] = useState(true);
  const [numPaymentSelect, setNumPaymentsSelect] = useState(1);
  const [disabledClick, setDisabledClick] = useState(false);
  const isPayInFlightRef = useRef(false);
  const hasDebitedRef = useRef(false);

  const CalcNumberPayments = (totalPrice) => {
    if (totalPrice >= 400) {
      return Math.floor(totalPrice / 200) < 4
        ? Math.floor(totalPrice / 200)
        : 4;
    }
    return 1;
  };
  const handleDebitTokenPayment = useCallback(
    async (token, amount, tokef) => {
      if (hasDebitedRef.current) return;
      hasDebitedRef.current = true;
      const roundedAmount = parseFloat(amount.toFixed(2));
      if (!user) {
        hasDebitedRef.current = false;
        return null;
      }
      const paymentData = {
        email: user.email,
        name: `${user.firstName} ${user.lastName}`,
        phone: user.phone,
        amount: roundedAmount,
        coupons: coupons,
        saveCard: save,
        comment: comment,
        paymentDetails: {
          Token: token,
          Tokef: tokef,
          Amount: roundedAmount,
          Tashloumim: numPaymentSelect,
          ClientName: `${user.firstName} ${user.lastName}`,
          Mail: user.email,
          Phone: user.phone,
          Groupe: "",
          Avour: "",
          Zeout: user.id,
          Currency: "1",
          Comment: comment,
        },
      };

      await closePayPopup(true, token, numPaymentSelect, paymentData);
    },
    [save, numPaymentSelect, coupons, comment, user, closePayPopup],
  );
  const pay = async (orderId) => {
    if (isPayInFlightRef.current) return;
    isPayInFlightRef.current = true;
    setDisabledClick(true);

    const unlockPay = () => {
      isPayInFlightRef.current = false;
      setDisabledClick(false);
    };

    try {
      if (tranmode) {
        if (!cardId) {
          showAlert({
            msgTitle: "שגיאה",
            msgText: "יש לבחור כרטיס לפני תשלום",
            msgType: "error",
          });
          unlockPay();
          return;
        }

        const Card = Cards.find((x) => x.token === cardId);

        if (!Card) {
          showAlert({
            msgTitle: "שגיאה",
            msgText: "הכרטיס שנבחר לא נמצא",
            msgType: "error",
          });
          unlockPay();
          return;
        }

        await handleDebitTokenPayment(
          Card.token,
          sum || SumPay,
          Card.expiry_date,
        );
      } else {
        await Payment({
          Id: cardId,
          Sum: total,
          OrderId: orderId,
          numPay: numPaymentSelect,
        });

        dispatch(setPreload(false));
      }
    } catch (err) {
      unlockPay();
      if (err.message === "NO_CARD") {
        showAlert({
          msgTitle: "שגיאה",
          msgText: "יש לבחור כרטיס לפני תשלום",
          msgType: "error",
        });
        return;
      }
      closePayPopup(false);

      showAlert({
        msgTitle: "העסקה נכשלה",
        msgText: "אנא בדקו את פרטי הכרטיס או נסו כרטיס אחר",
        msgType: "error",
      });
    }
  };

  useEffect(() => {
    GetCards()
      .then((x) => {
        setCards(x.data.cards);
      })
      .catch((err) => console.error("GetCards error:", err));
  }, []);
  const total = Math.abs(Number(parseFloat(sum || SumPay || 0).toFixed(2)));
  const numPayments = CalcNumberPayments(total);

  const payBody = (
    <>
      {tranmode && deferredDeliveryFee != null && deferredDeliveryFee > 0 ? (
        <div className="pp-disclaimer">
          דמי משלוח בסך{" "}
          <strong>₪{Number(deferredDeliveryFee).toFixed(2)}</strong> אינם נגבים
          כעת — התשלום יבוצע ישירות לשליח בעת קבלת המשלוח.
        </div>
      ) : null}

      {numPayments > 1 ? (
        <p className="note pp-note">
          שימו לב: לא ניתן לשלם תשלומים בכרטיס דיירקט!
        </p>
      ) : null}

      {ShowCards && Cards.length ? (
        <div className="use-saved-card">
          ניתן לבחור כרטיס ששמור במערכת
          {Cards.map((x) => (
            <div key={x.token}>
              <input
                type="radio"
                name="savedCard"
                checked={cardId === x.token}
                onChange={() => setCardId(x.token)}
              />
              **** {x.last_four_digits}
            </div>
          ))}
          {cardId ? (
            <div>
              {numPayments ? (
                <SelectNumPay
                  numPayment={numPaymentSelect}
                  setNumPayment={setNumPaymentsSelect}
                  numPayments={numPayments}
                />
              ) : null}
              {!numPayments || numPaymentSelect ? (
                <button
                  type="button"
                  className="btn"
                  disabled={disabledClick}
                  onClick={() => pay(orderId)}
                >
                  אישור תשלום
                </button>
              ) : null}
            </div>
          ) : null}
          <button className="btn" onClick={() => setShowCards(false)}>
            ברצוני להשתמש בכרטיס אחר
          </button>
        </div>
      ) : (
        <>
          <div className="pp-save-card">
            <span className="pp-save-card__label">
              שמור פרטי כרטיס להזמנות הבאות
            </span>
            <div className="pp-save-card__options">
              {tranmode && numPayments ? (
                <SelectNumPay
                  numPayment={numPaymentSelect}
                  setNumPayment={setNumPaymentsSelect}
                  numPayments={numPayments}
                />
              ) : null}
              <label className="pp-radio">
                <input
                  type="radio"
                  name="saveCard"
                  checked={save === true}
                  onChange={() => setSave(true)}
                />
                <span>כן</span>
              </label>
              <label className="pp-radio">
                <input
                  type="radio"
                  name="saveCard"
                  checked={save === false}
                  onChange={() => setSave(false)}
                />
                <span>לא</span>
              </label>
            </div>
          </div>

          {save !== null && (
            <PayNedarim
              numPayments={numPayments}
              numPaymentSelect={numPaymentSelect}
              orderIdInNedarim={orderId}
              total={total}
              save={save}
              tranmode={tranmode}
              ClosePayPopup={closePayPopup}
              pay={pay}
              handleDebitTokenPayment={handleDebitTokenPayment}
            />
          )}
        </>
      )}
    </>
  );

  if (embedded) {
    return (
      <div className="co-card pp-page" dir="rtl">
        <div className="co-card__head co-card__head--spread">
          <div className="co-card__head-left">
            <span className="co-card__title">לתשלום</span>
          </div>
          <span className="pp-page__sum">₪{formatPrice(total)}</span>
        </div>
        <div className="co-card__body">{payBody}</div>
      </div>
    );
  }

  return (
    <div className="pp-overlay">
      <div className="pp-modal" dir="rtl" onClick={(e) => e.stopPropagation()}>
        <div className="pp-header">
          <button
            type="button"
            className="pp-close"
            aria-label="סגור"
            onClick={() => closePayPopup(false)}
          >
            ✕
          </button>
          <div className="pp-header__amount">
            <span className="pp-header__label">לתשלום</span>
            <span className="pp-header__sum">₪{formatPrice(total)}</span>
          </div>
        </div>
        {payBody}
      </div>
    </div>
  );
};

export default PayPopup;
